import { isToday, isWeekend, format } from 'date-fns';

const Event = ({ event, eventColor }) => {
    
    return (
        <div className="calendar__week-day-event">
            <div className="calendar__week-day-event-title calendar__week-day-event-title--prioriy-low"><span style={{backgroundColor: `${eventColor}`}}></span>{event.title}</div>
            <div className="calendar__week-day-event-timing">
                <span>{event.timeFrom}</span>
                <span>{event.timeTo}</span>
            </div>
        </div>
    );
};

export default Event;
